import { ProductId } from "Utility/Product";
import { EventType } from "../Events/EventType";

export enum PopupOfferType {
    SUNDAY_OFFER = 'sunday_offer',
    PAYER_REACTIVATION_OFFER = 'reactivation_offer',
    STARTER_OFFER = 'starter_offer',
    EVENT_OFFER = 'event_offer'
}

export const PopupOfferTypeMap = {
    [PopupOfferType.SUNDAY_OFFER]: {
        [ProductId.SUNDAY_OFFER_V2_44_99]: ProductId.SUNDAY_OFFER_V2_44_99,
        [ProductId.SUNDAY_OFFER_V2]: ProductId.SUNDAY_OFFER_V2,
    },
    [PopupOfferType.PAYER_REACTIVATION_OFFER]: {
        [ProductId.PAYER_REACTIVATION_OFFER]: ProductId.PAYER_REACTIVATION_OFFER,
        [ProductId.PAYER_REACTIVATION_OFFER_2]: ProductId.PAYER_REACTIVATION_OFFER_2,
        [ProductId.PAYER_REACTIVATION_OFFER_3]: ProductId.PAYER_REACTIVATION_OFFER_3,
    },
    [PopupOfferType.STARTER_OFFER]: {
        [ProductId.SPECIAL_OFFER]: ProductId.SPECIAL_OFFER,
    },
    [PopupOfferType.EVENT_OFFER]: {
        [EventType.XMAS_2021]: ProductId.XMAS_2021_OFFER
    }
};

export type PopupOffersOfType<T extends PopupOfferType> = (typeof PopupOfferTypeMap)[T];
